<style lang="scss" scoped>
.slide-5 {
  background-image: url(../../../assets/module4/slide5/bg-01.jpg);
  background-size: cover;
  background-position: center;
  height: calc(100% - 50px);
  padding-top: 50px;
  padding-left: 80px;
  padding-right: 70px;
}
h1 {
  font-size: 74px;
  line-height: 88px;
  max-width: 90%;
  margin-top: 20px;
  transform: rotate(-2deg);
  color: #f8dc61;
  span {
    display: inline-block;
    height: 10px;
    width: 50px;
  }
}
h1.big {
  color: #aa252c;
  font-size: 117px;
  line-height: 141px;
  text-align: right;
  max-width: none;
  margin-top: -0.8em;
}
h2 {
  font-size: 46px;
  line-height: 56px;
  color: #1c3965;
}
.left {
  width: 53%;
  flex: none;
  margin-right: 50px;
}
p {
  color: white;
  margin-bottom: 50px;
}
.tr {
  max-width: 80%;
}
h3 {
  font-size: 51px;
  line-height: 61px;
}
.highfive {
  transition: all 0.2s ease-out;
  width: 307px;
  display: block;
  position: absolute;
  bottom: 100px;
  left: 800px;
  img {
    width: 100%;
    height: auto;
  }
  &:hover {
    transform: scale(1.1);
  }
}
video {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  z-index: 10;
  box-shadow: 0px 0px 0px 100vw rgba(0, 0, 0, 0.9);
}
</style>

<template>
  <div class="slide-5">
    <transition name="fadeUp" appear>
      <video
        v-if="showVid"
        ref="video"
        autoplay
        src="@/assets/highfive.mp4"
      ></video>
    </transition>

    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 4">
        <h1>
          <span></span>When we want to say something our brains send the
          messages to
        </h1>
      </div>
    </transition>
    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 4" class="delay-1">
        <h1 class="big">our 2 lips.</h1>
      </div>
    </transition>
    <div class="flex">
      <div class="left">
        <transition name="scale" appear>
          <h2 v-show="slideIndex == 4" class="delay-2">
            And because my superpower is related to speech, we are going to play
            a funny game called phantom speech.
          </h2>
        </transition>
      </div>
      <transition name="fadeUp" appear>
        <img
          src="@/assets/module4/slide5/sophia-01.png"
          class="chars delay-3"
          v-if="slideIndex == 4"
        />
      </transition>
      <transition name="fadeUp" appear>
        <img
          src="@/assets/module4/slide5/photo-01.png"
          class="chars delay-4"
          v-if="slideIndex == 4"
        />
      </transition>
      <div class="flex-1">
        <transition name="scale" appear>
          <div class="tr delay-5" v-show="slideIndex == 4">
            <p>You will need someone in your family to play with.</p>
            <p>Ok let’s get started.</p>
          </div>
        </transition>
        <transition name="scale" appear>
          <h3 v-show="slideIndex == 4" class="delay-6">
            Choose 10 words each and take turns saying each one without making a
            sound
          </h3>
        </transition>
        <transition name="scale" appear>
          <p v-show="slideIndex == 4" class="delay-7">
            so you just form the word with your two lips but you stay silent, as
            if you are watching TV with the sound turned down.
          </p>
        </transition>
        <transition name="scale" appear>
          <p v-show="slideIndex == 4" class="delay-8">
            Give a high five to the person that guesses the most words correct.
          </p>
        </transition>
      </div>
    </div>
    <a href="#" class="highfive" @click.prevent="play">
      <transition name="fadeUp" appear>
        <img
          class="delay-4"
          v-if="slideIndex == 4"
          src="@/assets/module1/slide26/high_five.svg"
        />
      </transition>
    </a>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"],
  data: function() {
    return {
      showVid: false
    };
  },
  methods: {
    play() {
      this.showVid = true;
      this.$nextTick(() => {
        if (this.$refs.video) {
          this.$refs.video.addEventListener(
            "ended",
            () => {
              this.showVid = false;
            },
            false
          );
        }
      });
    }
  }
};
</script>
